import { helper } from '@ember/component/helper';

export function eq(params /*, hash*/) {
    if (params.length < 2) return false;
    let [a, b] = params;
    return a === b;
}

export default helper(eq);
